import { useState } from "react";
import * as yup from 'yup';

const useHandleForm = (data, duplicateCallback, invalidDataCallback) => {

  const isCreate = !Boolean(data);

  const createInitialData = () => {

    const getInitialFieldData = (fieldName) => {
      return isCreate ? "" : data[fieldName];
    }

    const fieldNames = [
      "name",
      "group",
      "description",
    ];

    return fieldNames.reduce((initialData, fieldName) => {
      return ({
        ...initialData,
        [fieldName]: getInitialFieldData(fieldName)
      })
    }, {});
  }

  const [formData, setFormData] = useState(createInitialData());

  const dataIsValid = async () => {
    const nameRegex = /^[a-zA-ZÑÁÉÍÓÚ][a-zA-Z0-9ÑÁÉÍÓÚ]*/;

    let schema = yup.object().shape({
      name: yup.string().matches(nameRegex).required(),
      description: yup.string().required(),
      group: yup.string().matches(nameRegex).required(),
    });

    return await schema.isValid(formData).then((valid) => valid);
  }

  const submit = async () => {
    if (await dataIsValid()) {
      let dataToSend = { ...formData };

      duplicateCallback({ ...dataToSend, ref: data.code });
      return true;
    } else {
      invalidDataCallback();
      return false;
    }
  }

  const setFormValue = (value, fieldName) => {
    setFormData({
      ...formData,
      [fieldName]: value,
    })
  }

  return { isCreate, formData, setFormValue, submit };
}

export default useHandleForm;